export default [
  {
    description: 'Termo Controlado',
    path: '/ged/termo-controlado',
    name: 'ged-termo-controlado',
    component: () => import('@/views/ged/gedtermocontrolado/Index.vue'),
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Termo Controlado',
    parent: 'ged-termo-controlado',
    path: '/ged/termo-controlado/cadastro/:id?',
    name: 'ged-termo-controlado-create',
    component: () => import('@/views/ged/gedtermocontrolado/InclusaoEdicao.vue'),
    goesToMenu: false,
  },
  {
    description: 'Itens de Termo Controlado',
    parent: 'ged-termo-controlado',
    path: '/ged/termo-controlado/:id/itens',
    name: 'ged-termo-controlado-itens',
    component: () => import('@/views/ged/gedtermocontrolado/GridItens.vue'),
    goesToMenu: false,
  },
];
